
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        label: String,
        id: String,
        name: String,
        value: [String, Number],
        isChecked: Boolean,
    },
    emits: ['radioClicked'],
    setup(props, context) {
        const clicked = (): void => {
            context.emit('radioClicked')
        }
        return {
            clicked,
        }
    },
})
